/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.ai.rpc.CatalogItemRecommendationRpc
 */
import * as References from './CatalogItemRecommendationRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.ai.rpc.CatalogItemRecommendationRpc#getSimilarItems
 */
export const GET_SIMILAR_ITEMS_QUERY_FIELD_NAME = 'com_hubspot_academy_ai_rpc_CatalogItemRecommendationRpc_getSimilarItems';
export const GET_SIMILAR_ITEMS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SIMILAR_ITEMS_QUERY_FIELD_NAME,
  args: ['itemKey', 'itemTypes', 'languages', 'limit'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getSimilarItemsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});